/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Coins = [
  ["path", { d: "M13.744 17.736a6 6 0 1 1-7.48-7.48" }],
  ["path", { d: "M15 6h1v4" }],
  ["path", { d: "m6.134 14.768.866-.5 2 3.464" }],
  ["circle", { cx: "16", cy: "8", r: "6" }]
];

export { Coins as default };
//# sourceMappingURL=coins.js.map
